import { Page } from '@/core/architecture'

import { ThreadEditTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ThreadCreate Page
 * Implemented as a practical sample.
 */
export const ThreadEdit: Page = () => {
  const { state, actions } = useViewModel()

  return <ThreadEditTemplate state={state} {...actions} />
}
